module.exports = __webpack_public_path__ + "media/images/communities/logos/ao6-f8b09fa6890d22ac9d5bacb30f2bca00.png";